






import Vue from 'vue'
import { SpotColor } from '@/common/types/spotColor'
export default Vue.extend({
  props: {
    spotColor: {
    type: Object as () => SpotColor,
    required: true
    }
  }})
